import { getSession, removeSession, setSession } from "./ComUtils";

import Cookies from 'js-cookie';
import Path from "../router/path";

const LOGIN_FORM_KEY = 'LOGIN_FORM_KEY';
const USER_INFO_KEY = 'USER_INFO_KEY';
// 登录前url记录key
const BEFORE_LOGIN_URL_KEY = "BEFORE_LOGIN_URL_KEY";
// 按钮权限
const BUTTON_PERMISSIONS = 'BUTTON_PERMISSIONS';

// 登录信息
export function cacheLoginForm(loginForm) {
  Cookies.set(LOGIN_FORM_KEY, loginForm, { expires: 7 });
}

export function getCachedLoginForm() {
  return Cookies.get(LOGIN_FORM_KEY);
}

// 用户信息
export function cacheUserInfo(userInfo) {
  if (typeof userInfo !== "string") {
    userInfo = JSON.stringify(userInfo);
  }
  setSession(USER_INFO_KEY, userInfo);
}
export function getCachedUserInfo() {
  try {
    return JSON.parse(getSession(USER_INFO_KEY));
  } catch (e) {
    removeCacheUserInfo();
    console.log("err when get cached user info", e);
    return {};
  }
}
export function removeCacheUserInfo() {
  removeSession(USER_INFO_KEY);
}

// 记忆路径函数封装
export function rememberPath() {
  // 如果路径不是login登录，则将路径存登录前url记录key的cookie
  if (window.location.pathname.indexOf(Path.LOGIN) < 0) {
    Cookies.set(BEFORE_LOGIN_URL_KEY, window.location.pathname + window.location.search);
  }
}

// 获取记忆路径
export function getRememberedPath() {
  return Cookies.get(BEFORE_LOGIN_URL_KEY);
}

// 缓存按钮权限
export function cacheBtnPerms(perms) {
  setSession(BUTTON_PERMISSIONS, JSON.stringify(perms));
}

export function getCachedBtnPerms() {
  try {
    return JSON.parse(getSession(BUTTON_PERMISSIONS));
  } catch (e) {
    removeSession(BUTTON_PERMISSIONS);
    console.log("err when get cached button permissions", e);
    return [];
  }
}

/**
 * 检查权限
 * @param perm
 */
export function checkPermission(targetPerm) {
  if (!targetPerm) return true;
  const perm_type = typeof targetPerm;
  const permissions = getCachedBtnPerms();
  if (perm_type === "string") {// 如果是字符串
    return permissions.some(p => p === targetPerm);
  } else if (perm_type === "object") {
    if (Array.isArray(targetPerm)) {// 如果是数组
      return permissions.some(p => targetPerm.some(tp => tp === p));
    }
    return false;
  }
  return false;
}
